<template>
  <div>
    <h1 class="subtitle is-1 has-text-primary">Worth while</h1>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
</style>
